export default __webpack_public_path__ + "static/novelscats-3470e1c6bfd5d1ad06042ae025d52e50.png";